<template>
  <vs-popup title="Share Live Location" :active.sync="localData">
    <div class="flex flex-col overflow-hidden">
      <p>
        Silakan tentukan durasi berapa lama <i>live location</i> ini akan
        dibagikan.
      </p>
      <div class="flex flex-row w-full">
        <div v-for="dur in durations" class="w-1/3 p-3">
          <vs-button
            class="w-full"
            color="danger"
            :type="dur.value == selectedDuration ? 'filled' : 'border'"
            @click="selectedDuration = dur.value"
            >{{ dur.label }}</vs-button
          >
        </div>
      </div>
      <div class="w-full p-3">
        <vs-select class="selectExample w-full" v-model="baseMap">
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in mapOptions" />
        </vs-select>
      </div>
      <div class="mt-5 w-full">
        <vs-button color="danger" class="flex ml-auto" @click="handleShare"
          >Share</vs-button
        >
      </div>
    </div>
  </vs-popup>
</template>

<script>
import * as REPO from '../../repository/index'
import * as moment from 'moment'

export default {
  props: {
    openModal: Boolean,
    data: String,
  },
  data() {
    return {
      baseMap: 'openstreetmap',
      mapOptions: [
        {
          text: 'Open Street Map',
          value: 'openstreetmap',
        },
        {
          text: 'Google Map',
          value: 'googlemap',
        },
      ],
      selectedDuration: moment().add(4, 'hours').format('YYYY-MM-DD HH:mm:ss'),
      durations: [
        {
          label: '4 Jam',
          value: moment().add(4, 'hours').format('YYYY-MM-DD HH:mm:ss'),
        },
        {
          label: '8 Jam',
          value: moment().add(8, 'hours').format('YYYY-MM-DD HH:mm:ss'),
        },
        {
          label: '24 Jam',
          value: moment().add(24, 'hours').format('YYYY-MM-DD HH:mm:ss'),
        },
      ],
    }
  },
  computed: {
    localData: {
      get() {
        //
        return this.openModal
      },
      set(val) {
        if (!val) {
          this.$emit('closeModal')
        }
      },
    },
  },
  // for testing pupose
  // watch: {
  //   selectedDuration(val) {
  //
  //   },
  // },
  methods: {
    close() {
      this.$emit('closeModal', false)
    },
    handleShare() {
      const param = {
        vehicle_id: this.data,
        expired_date: this.selectedDuration,
        map: this.baseMap,
      }
      REPO.postLiveMonitoring(param).then((res) => {
        const token = res.data.data.token
        const link = `${window.location.origin}/live-track/${token}`
        navigator.clipboard.writeText(link)
        this.$vs.notify({
          title: 'Berhasil',
          text: 'Live share link telah berhasil disalin ke clipboard',
          color: 'success',
        })
        this.$emit('closeModal', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>
